import * as React from "react";
import * as ReactIcons from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";

import IconMenu from "@mui/icons-material/Menu";
import IconChevronLeft from "@mui/icons-material/ChevronLeft";
import IconChevronRight from "@mui/icons-material/ChevronRight";
import IconMail from "@mui/icons-material/Mail";
import IconHome from "@mui/icons-material/Home";
import IconExpandLess from "@mui/icons-material/ExpandLess";
import IconExpandMore from "@mui/icons-material/ExpandMore";
import IconoMaestros from "@mui/icons-material/Polyline";
import IconoArticulos from "@mui/icons-material/LocalOffer";
import IconoUnidadMedida from "@mui/icons-material/SquareFoot";
import IconoTamanos from "@mui/icons-material/FormatSize";
import IconoPresentaciones from "@mui/icons-material/Style";
import IconoPresentaciones2 from "@mui/icons-material/Looks";
import IconoTipos from "@mui/icons-material/Pages";
import IconoSubTipos from "@mui/icons-material/OpenWith";
import IconoEntidadesExternas from "@mui/icons-material/PeopleAlt";
import IconoClientes from "@mui/icons-material/AssignmentInd";
import IconoProveedores from "@mui/icons-material/Accessibility";
import IconoPersonas from "@mui/icons-material/Person";
import IconoProfesionales from "@mui/icons-material/AutoAwesome";
import IconoCompanias from "@mui/icons-material/Business";
import IconoEmpresas from "@mui/icons-material/Factory";
import IconoPlantas from "@mui/icons-material/Store";
import IconoDepositos from "@mui/icons-material/Warehouse";
import IconoUbicaciones from "@mui/icons-material/LocationSearching";
import IconoCuentasFinancieras from "@mui/icons-material/AttachMoney";
import IconoCuentasContables from "@mui/icons-material/AccountTree";
import IconoBancos from "@mui/icons-material/AccountBalance";
import IconoCondicionesVenta from "@mui/icons-material/BlurOn";
import IconoCentrosCosto from "@mui/icons-material/FilePresent";
import IconoSubCentrosCosto from "@mui/icons-material/AttachFile";
import IconoMonedas from "@mui/icons-material/LocalAtm";
import IconoPuntosDeVenta from "@mui/icons-material/Storefront";
import IconoVentas from "@mui/icons-material/Store";
import IconoDocumentosVenta from "@mui/icons-material/LocalGroceryStore";
import IconoRecibos from "@mui/icons-material/PointOfSaleOutlined";
import IconoCompras from "@mui/icons-material/Storefront";
import IconoDocumentosCompra from "@mui/icons-material/ShoppingCartCheckout";
import IconoPagos from "@mui/icons-material/PointOfSale";
import IconoContabilidad from "@mui/icons-material/Timeline";
import IconoInventario from "@mui/icons-material/Inventory";
import IconoProduccion from "@mui/icons-material/PrecisionManufacturing";
import IconoRRHH from "@mui/icons-material/PeopleAlt";
import { useNavigate } from "react-router-dom";
import LogoN7 from '../Img/LogoN7_FondoTransparente.png';
import { function_ABM_ZON_Plantas_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";

const drawerWidth = 310;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function DrawerComponent({ IdPersona }) {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [menuList, setMenuList] = React.useState([]);
  const [submenuStates, setSubmenuStates] = React.useState([]);
  const { TODOS_Menues: { function_TODOS_Menues_GenerarArbolDeMenues } } = require('neftis7_apicaller');
  const navigate = useNavigate();
  const [logo, setLogo] = React.useState(null);

  React.useEffect(() => {
    try {
      const defaultLogo = require(`./../Img/${localStorage.getItem("CodigoCompania")}/${localStorage.getItem("CodigoEmpresa")}/${localStorage.getItem("CodigoPlanta")}/logoFondoTransparente.png`);
      setLogo(defaultLogo);
    } catch (error) {
      const fallbackLogo = require(`./../Img/LogoLV_FondoTransparente.png`);
      setLogo(fallbackLogo);
    }

    try {
      const codigoCompania = localStorage.getItem("CodigoCompania");
      const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
      const codigoPlanta = localStorage.getItem("CodigoPlanta");

      const getData = async () => {
        const datosDocumento = await function_ABM_ZON_Plantas_Leer(codigoPlanta)

        if (datosDocumento.data[0]?.Logo) {
          let mimeType = "image/jpeg"; // Valor por defecto

          // Detectar el formato a partir del encabezado de la cadena Base64
          if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
          else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
          else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

          const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
          setLogo(logoUrl);
        }
      }

      getData()
    } catch (error) {
      const fallbackLogo = require(`./../Img/LogoLV_FondoTransparente.png`);
      setLogo(fallbackLogo);
    }

    fetchMenuData();
  }, []);

  const fetchMenuData = async () => {
    try {
      const response = await function_TODOS_Menues_GenerarArbolDeMenues(IdPersona);
      const responseData = response.data;

      const menuListWithIcons = responseData.map(item => {
        // Interpreta el nombre del icono y obtén el componente de icono correspondiente
        const IconComponent = ReactIcons[item.icon];

        // Retorna el objeto de menú actualizado con el componente de icono
        return {
          ...item,
          icon: <IconComponent /> // Usa el componente de icono correspondiente
        };
      });

      // Agregar el ítem "SALIR" al final de la lista de menús
      menuListWithIcons.push({
        name: "SALIR",
        icon: <IconoBancos />,
      });

      setMenuList(menuListWithIcons);

      setSubmenuStates(new Array(response.length).fill(false));
    } catch (error) {
      alert('Error fetching menu data:', error);
    }
  };

  const handleExitClick = () => {
    localStorage.setItem("isLoggedIn", false);
    localStorage.setItem("user", null);
    localStorage.setItem("IdPersona", 0);
    localStorage.setItem("EsAdmin", false);
    localStorage.setItem("CodigoCompania", null);
    localStorage.setItem("CodigoEmpresa", null);
    localStorage.setItem("CodigoPlanta", null);
    localStorage.setItem("Terminal", 0);
    console.log("Saliendo...");
    navigate("/Login");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const toggleSubmenu = (index, link) => {
    const newSubmenuStates = [...submenuStates];
    newSubmenuStates[index] = !newSubmenuStates[index];
    setSubmenuStates(newSubmenuStates);

    if (link) {
      if (link !== "/") {
        window.location.href = link; // Redirige al usuario a la página correspondiente
      }
    }
  };

  const subMenuComponent = (submenu, index) => {
    return (
      <Collapse in={submenuStates[index]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {submenu.map((item, subIndex) => (
            <ListItem
              key={subIndex}
              button
              sx={{ pl: 4 }}
              onClick={() => handleSubMenuClick(index, subIndex, item.link)}
            >
              <ListItemIcon>
                {item.icon && React.createElement(ReactIcons[item.icon])}
              </ListItemIcon>
              <ListItemText primary={item.name} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    );
  };

  const handleSubMenuClick = (index, subIndex, link) => {
    window.location.href = link; // Redirige al usuario a la página correspondiente
  };

  const menuComponent = menuList.map((item, index) => (
    <div key={index}>
      <ListItem
        button
        onClick={() => item.name === "SALIR" ? handleExitClick() : toggleSubmenu(index, item.link)}
      >
        <ListItemIcon>{item.icon}</ListItemIcon>
        <ListItemText primary={item.name} />
        {item.submenu && (submenuStates[index] ? <IconExpandLess /> : <IconExpandMore />)}
      </ListItem>
      {item.submenu && subMenuComponent(item.submenu, index)}
    </div>
  ));

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <IconMenu />
          </IconButton>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            {/* Izquierda: Logo */}
            <div style={{ display: 'flex', alignItems: 'center', minWidth: '150px' }}>
              <img
                src={LogoN7}
                alt="Logo N7"
                style={{ maxHeight: '50px', marginRight: '10px', objectFit: 'contain' }}
              />
              {logo && (
                <img
                  src={logo}
                  alt="Logo"
                  style={{ maxHeight: '50px', marginRight: '10px', objectFit: 'contain' }}
                />
              )}
            </div>

            {/* Centro: Título */}
            <div style={{ fontSize: '1.5rem', textAlign: 'center', flexGrow: 1 }}>
              NEFTIS 7
            </div>

            {/* Derecha: Info */}
            <div style={{ fontSize: '0.9em', textAlign: 'right', minWidth: '250px' }}>
              {localStorage.getItem("DescripcionEmpresa")} - {localStorage.getItem("DescripcionPlanta")} - {localStorage.getItem("Usuario")} - Terminal: {localStorage.getItem("Terminal")}
            </div>
          </div>

        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <IconChevronLeft />
            ) : (
              <IconChevronRight />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {menuComponent}
        </List>
      </Drawer>
    </Box>
  );
}
